import React from "react";

// Components
import ContentCard from "../../../../UI/ContentCard/ContentCard";

// Images
import innovationImg from "../../../../assests/images/innovation.png";

const ConceptInnovation = () => (
  <ContentCard
    title="OPEN FOR INNOVATION"
    id="Innovation"
    image={innovationImg}
    imageTitle="OPEN FOR INNOVATION"
    frontText="We directly organize the chain of sourcing and production."
    backTextOne="We directly organize the chain of sourcing and production. Therefore we are able to
          instantly implement new ideas into our clothes. We know that there are a lot of
          startups and inventors out there who have great products and ideas that could be
          integrated into garments. But your core business is technical innovation rather than
          sewing clothes."
    backTextTwo="Therefore we invite inventors and startups to add their inventions into our repertoire
          of customer options. With every product sold you recieve the share we agreed on in advance."
    backTextThree="With our concept we provide an open innovative market test field for new ideas.
          You don‘t need to wait for big brands to decide if they want to integrate your ideas.
          Neither do you have to figure out the whole textile production chain by yourself.
          You can just focus on your core business and we provide the rest."
  />
);

export default ConceptInnovation;



// WEBPACK FOOTER //
// ./src/components/Pages/Concept/Content/ConceptInnovation.js